import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  statusTagWrapper: {
    display: "flex",
    gap: "8px",
    alignItems: "baseline",
    textTransform: "capitalize",
    "& p":{
        fontSize: "14px",
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 400,
        letterSpacing: '0.17px'
    },
    "& svg": {
      width: "8px",
      height: "8px",
    },
    "& .success": {
      color: "#2E7D32",
    },
    "& .pending-auth": {
      color: "#EF6C00",
    },
    "& .de-authorized": {
      color: "#7E57C2",
    },
    "& .warning":{
      color: "#E65100"
    },
    "& .default": {
      color: "#BDBDBD",
    },
    "& .danger": {
      // borderRadius: "100px",
      color: " #D32F2F",
    },
  },
}));
